module.exports = __webpack_public_path__ + "img/logo3.d32fca13.png";